import React from "react"
import SaleStage from "../components/SaleStage"

class Step8SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { titleTransfer={} } = (client && client.stages_of_sale) || {};

        const {
            birAssessmentFile,
            birAssessmentDate,
            cwt1606PaymentSlip,
            cwtPaymentDate,
            dst2000OTPaymentSlip,
            dst2000OTPaymentDate,
            file0605PaymentSlip,
            file0605PaymentDate,
            carSlip,
            originalCarFile,
            transferTaxReceiptFile,
            deedOfUndertaking,
            rptTransferTax,
            rdAssessmentFile,
            rdOr,
            dateTitleTransferUnderBuyersName,
            isCompleted,
            completionDate,
            others=[]
        } = titleTransfer;

        const step8Fields = [
            { key: 'birAssessmentFile', type: 'file', label: 'BIR Assessment File', value: birAssessmentFile},
            { key: 'birAssessmentDate', type: 'date', label: 'BIR Assessment Date', value: birAssessmentDate},
            { key: 'cwt1606PaymentSlip', type: 'file', label: 'CWT 1606 Payment Slip', value: cwt1606PaymentSlip},
            { key: 'cwtPaymentDate', type: 'date', label: 'CWT Payment Date', value: cwtPaymentDate},
            { key: 'dst2000OTPaymentSlip', type: 'file', label: 'DST 2000-OT Payment Slip', value: dst2000OTPaymentSlip},
            { key: 'dst2000OTPaymentDate', type: 'date', label: 'DST 2000-OT Payment Date', value: dst2000OTPaymentDate},
            { key: 'file0605PaymentSlip', type: 'file', label: '0605 Payment Slip', value: file0605PaymentSlip},
            { key: 'file0605PaymentDate', type: 'date', label: '0605 Payment Date', value: file0605PaymentDate},
            { key: 'carSlip', type: 'file', label: 'CAR Slip', value: carSlip},
            { key: 'originalCarFile', type: 'file', label: 'Original CAR File', value: originalCarFile},
            { key: 'transferTaxReceiptFile', type: 'file', label: 'Transfer Tax Receipt', value: transferTaxReceiptFile},
            { key: 'deedOfUndertaking', type: 'file', label: 'Deed of Undertaking', value: deedOfUndertaking},
            { key: 'rptTransferTax', type: 'date', label: 'RPT Transfer Tax', value: rptTransferTax},
            { key: 'rdAssessmentFile', type: 'file', label: 'RD Assessment File', value: rdAssessmentFile},
            { key: 'rdOr', type: 'file', label: 'RD OR', value: rdOr},
            { key: 'dateTitleTransferUnderBuyersName', type: 'date', label: 'Date Title Transfer Under Buyers Name', value: dateTitleTransferUnderBuyersName},
        ]

        return (
            !!client ? <SaleStage 
                title="Title Transfer"
                fields={step8Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="titleTransfer"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step8SS
